export const isServer = !(typeof window !== 'undefined' && window.document?.createElement);

export const isBrowser: boolean = typeof window !== 'undefined' && window.document?.createElement != null;

export const isTest = typeof describe === 'function' && typeof it === 'function' && typeof expect === 'function';
